var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-edit",
    transform: "translate(-357 -538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-primary",
    transform: "translate(357 538)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 36,
    height: 36,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(363.168 546.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5900",
    "data-name": "Path 5900",
    d: "M19.451,7.141a1.351,1.351,0,0,0,0-1.956L16.936,2.669a1.351,1.351,0,0,0-1.956,0L4.5,13.149v4.471H8.971ZM15.958,3.647l2.515,2.515-2.1,2.1L13.862,5.743ZM5.9,16.223V13.708l6.987-6.987L15.4,9.237,8.413,16.223Z",
    transform: "translate(0 0)",
    fill: "#213364"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.45a1f0c0f293035b7e06ea73ce80e35c.svg";
export { ForwardRef as ReactComponent };